export function clearEmptyFields(obj) {
  if(obj)
    return Object.entries(obj)
      .filter(([_, v]) => (v !== null) && (v !== '') && (v !== undefined))
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
};